import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShipmentTrackFilterEntity } from '../../domain/entities/ShipmentTrackFilterEntity'

export class ShipmentTrackFilterModel extends ShipmentTrackFilterEntity {
  regionIds!: number[]
  channelIds!: number[]
  constructor(dataDto: ShipmentTrackFilterEntity) {
    super()
    mapEntityProperties<ShipmentTrackFilterModel>(this, dataDto, {
      map: {
        regionIds: dataDto.regions?.map((region) => region.id),
        channelIds: dataDto.channels?.map((channel) => channel.id),
        shipmentStatuses: dataDto.shipmentStatuses ?? []
      }
    })
  }
}
